const SchoolIcon = (props: any): any => (
    <svg
        version="1.1"
        width="511pt"
        height="511pt"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={props.fill ?? '#757575'}
        className={props.className}
        style={props.style}
    >
        <path d="M5 13.18v2.81c0 .73.4 1.41 1.04 1.76l5 2.73c.6.33 1.32.33 1.92 0l5-2.73c.64-.35 1.04-1.03 1.04-1.76v-2.81l-6.04 3.3c-.6.33-1.32.33-1.92 0zm6.04-9.66-8.43 4.6c-.69.38-.69 1.38 0 1.76l8.43 4.6c.6.33 1.32.33 1.92 0L21 10.09V16c0 .55.45 1 1 1s1-.45 1-1V9.59c0-.37-.2-.7-.52-.88l-9.52-5.19a2.04 2.04 0 0 0-1.92 0"></path>
    </svg>
);
export default SchoolIcon;
